import { getUserUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

export default function DisplayNameLink({
  userId,
  username,
  displayName,
  variant = 'subtle-gray',
}: {
  userId: number
  username: string | null
  displayName: string
  variant?: string
}): JSX.Element {
  return (
    <ShwLink href={getUserUrl({ userId, username })} variant={variant} textDecoration="underline">
      {displayName}
    </ShwLink>
  )
}
